"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationMenuItem = void 0;
const react_1 = __importStar(require("react"));
const Icon_1 = require("../../../Icon");
const NavigationMenuItem_styles_1 = require("./NavigationMenuItem.styles");
exports.NavigationMenuItem = react_1.default.memo(function NavigationMenuItem({ title, url, active, icon, onClick, triangleColor, hideBorder, ['data-selector-id']: initialDataSelectorId }) {
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || `navigation-${url ? 'link' : 'item'}`, [initialDataSelectorId, url]);
    return url ? (react_1.default.createElement(NavigationMenuItem_styles_1.StyledNavigationMenuItemLink, { href: url, "data-selector-id": dataSelectorId, onClick: onClick, triangleColor: triangleColor, hideBorder: hideBorder, active: active },
        icon && react_1.default.createElement(NavigationMenuItem_styles_1.StyledNavigationMenuItemIcon, { src: icon, size: Icon_1.ICON_SIZES.m }),
        react_1.default.createElement(NavigationMenuItem_styles_1.StyledNavigationMenuItemText, { active: active, truncate: true }, title))) : (react_1.default.createElement(NavigationMenuItem_styles_1.StyledNavigationMenuItemBlock, { "data-selector-id": dataSelectorId, onClick: onClick, triangleColor: triangleColor, hideBorder: hideBorder, active: active },
        icon && react_1.default.createElement(NavigationMenuItem_styles_1.StyledNavigationMenuItemIcon, { src: icon, size: Icon_1.ICON_SIZES.m }),
        react_1.default.createElement(NavigationMenuItem_styles_1.StyledNavigationMenuItemText, { active: active, truncate: true }, title)));
});
//# sourceMappingURL=NavigationMenuItem.js.map